import { PROFILE, LOGIN } from '../routes/paths';

export function getLoginDestination(pathname, search = '') {
  const eventRoute = pathname.match(/^\/(events\/(?:detail|album|join|upload-join|invitation\/accept)|upload-event-images)\/([^/]+)\/?$/);
  if (!eventRoute) return LOGIN;

  const params = new URLSearchParams(search);
  const query = new URLSearchParams({ event_code: decodeURIComponent(eventRoute[2]) });
  const eventDestinations = ['events/detail', 'events/album'];
  const redirectTo = eventDestinations.includes(eventRoute[1]) ? eventRoute[1]
    : eventDestinations.includes(params.get('redirect-to')) ? params.get('redirect-to')
    : eventRoute[1].includes('upload')
    ? 'upload-event-images'
    : params.get('redirect-to');
  if (redirectTo) query.set('redirect-to', redirectTo);
  return `${LOGIN}?${query.toString()}`;
}

export function getAuthDestination(eventCode, redirectTo) {
  if (!eventCode) return PROFILE;
  const code = encodeURIComponent(eventCode);
  if (['events/detail', 'events/album'].includes(redirectTo)) return `/${redirectTo}/${code}`;
  return redirectTo === 'upload-event-images'
    ? `/upload-event-images/${code}`
    : `/events/invitation/accept/${code}`;
}

export function getAuthEntry(eventCode, redirectTo) {
  if (!eventCode) return LOGIN;
  const code = encodeURIComponent(eventCode);
  if (['events/detail', 'events/album'].includes(redirectTo)) return `/events/upload-join/${code}?redirect-to=${redirectTo}`;
  return redirectTo === 'upload-event-images'
    ? `/events/upload-join/${code}?redirect-to=upload-event-images`
    : `/events/join/${code}`;
}

export function getAccountCompletionDestination(eventCode, redirectTo) {
  if (!eventCode) return PROFILE;
  const code = encodeURIComponent(eventCode);
  if (['events/detail', 'events/album'].includes(redirectTo)) return `/${redirectTo}/${code}`;
  return redirectTo === 'upload-event-images'
    ? `/upload-event-images/${code}`
    : `/events/join/${code}`;
}
